export const truncate = (str: string, length: number = 128) => {
    return str.length > length ? `${str.slice(0, length - 2)}...` : str;
};
